/**
 * @file BaseConsentComponent.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { ConsentViewModel } from "../../viewmodel/ConsentViewModel";
import { Consent } from "../../../../services/models/Consent";
import { BaseComponent } from "../../../home/base/BaseComponent";
import { defaultLanguage } from "../../../utils/AppConstant";
import { ConsentTranslation } from "../../../../services/models/ConsentTranslation";

 /**
 * A class definition for BaseConsentComponent
 */
export class BaseConsentComponent<BaseProps, State> extends BaseComponent<BaseProps, State> {

    protected consentViewModel: ConsentViewModel;
    protected consent: Consent[];

    constructor(props: BaseProps) {
        super(props);
        this.consentViewModel = new ConsentViewModel();
    }

        /**
         * Get's specified language translation
         * @param languageCode string
         * @returns 
         */
        protected getLanguageConsentContent = (languageCode: string, root: string)=> {
            this.logger.verbose(`getLanguageConsentContent() Language = ${defaultLanguage}`, root);
            
            if( (!this.consent || this.consent.length <=0) || (!this.consent[0].versions || this.consent[0].versions.length <= 0) || (!this.consent[0].versions[0].translations || this.consent[0].versions[0].translations.length <= 0)) {
                return; // Error Handle if there is no consent found
            }
            this.logger.verbose(`${JSON.stringify(this.consent)}`, root);
            // eslint-disable-next-line
            const translation = this.consent[0].versions[0].translations.find(((translation: ConsentTranslation) =>translation.language === languageCode));
            this.logger.verbose(`getLanguageConsentContent() translation = ${translation?.content.content}`, root);

            // make a fallback mechanism if translation is not available
            if (!translation) {
                const translation = this.consent[0].versions[0].translations.find(((translation: ConsentTranslation) => translation.language === defaultLanguage.code));
                const copyTranslation = {...translation as ConsentTranslation};
                copyTranslation.language = languageCode; // eslint-disable-line

                return copyTranslation;
            }
            return translation;

        }    
}